import { getActiveLoginType, sessionStoreFor } from "services/loginTypeStorage";

const authStorage = {
  getItem(key: string): Promise<string | null> {
    return Promise.resolve(sessionStoreFor(getActiveLoginType()).get(key));
  },
  setItem(key: string, value: string): Promise<void> {
    sessionStoreFor(getActiveLoginType()).set(key, value);
    return Promise.resolve();
  },
  removeItem(key: string): Promise<void> {
    sessionStoreFor(getActiveLoginType()).remove(key);
    return Promise.resolve();
  },
};

export default authStorage;
